import LocalizedStrings from 'react-localization'
import en from './lang/en'
import es from './lang/es'

export const locale = new LocalizedStrings({ en, es })
export const langs = locale.getAvailableLanguages()



// WEBPACK FOOTER //
// ./shared-assets/i18n/langs.js